import React, { useEffect, useRef } from 'react';

export const FirmaCanvas = ({ onChange }) => {
  const ref = useRef(null);
  const disegno = useRef(false);

  const pulisci = () => {
    const c = ref.current;
    const ctx = c.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.strokeStyle = '#0f172a';
    ctx.lineWidth = 2.2;
    ctx.lineCap = 'round';
    onChange(null);
  };

  useEffect(pulisci, []);

  const punto = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [(e.clientX - r.left) * (ref.current.width / r.width), (e.clientY - r.top) * (ref.current.height / r.height)];
  };
  const inizio = (e) => {
    disegno.current = true;
    ref.current.setPointerCapture(e.pointerId);
    const ctx = ref.current.getContext('2d');
    ctx.beginPath();
    ctx.moveTo(...punto(e));
  };
  const muovi = (e) => {
    if (!disegno.current) return;
    const ctx = ref.current.getContext('2d');
    ctx.lineTo(...punto(e));
    ctx.stroke();
  };
  const fine = () => {
    if (!disegno.current) return;
    disegno.current = false;
    onChange(ref.current.toDataURL('image/png'));
  };

  return (
    <div>
      <canvas ref={ref} width={500} height={180} onPointerDown={inizio} onPointerMove={muovi} onPointerUp={fine}
        onPointerLeave={fine} className="w-full touch-none rounded-xl border-2 border-dashed border-gray-300 bg-white"
        data-testid="pulizie-firma-canvas" />
      <button onClick={pulisci} className="mt-1 text-xs text-gray-500 hover:text-gray-800" data-testid="pulizie-firma-cancella">
        Cancella firma
      </button>
    </div>
  );
};
